import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { take } from 'rxjs';
import { FinancialYearService } from 'src/app/services/financial.year.service';
import { UserAuthService } from 'src/app/services/user-auth.service';
import { ZohoImService } from 'src/app/services/zoho-im.service';
@Component({
  selector: 'app-redirecting',
  imports: [RouterModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './redirecting.component.html',
  styleUrl: './redirecting.component.scss',
})
export class RedirectingComponent implements OnInit, OnDestroy {
  router = inject(Router);
  private route = inject(ActivatedRoute);
  userAuthService = inject(UserAuthService);
  financialYearService = inject(FinancialYearService);
  private readonly zohoImService = inject(ZohoImService);
  showButton = false;
  private hideButtonTimer: any;
  showMessage = false;
  private messageTimer: any;
  ngOnInit() {
    const queryParams = this.route.snapshot.queryParams;
    const isCallback = 'code' in queryParams;
    const goToHome = 'Home' in queryParams;

    if (!isCallback) {
      //set the visit company keys in the session storage
      if ('v_id' in queryParams) {
        sessionStorage.setItem('v_id', queryParams['v_id']);
        sessionStorage.setItem('v_n', queryParams['v_n']);

        // Switching company forgets any saved Zoho support chat, so the new company starts a new one.
        this.zohoImService.logout();

        if (this.userAuthService.systemId() == 28) {
          this.financialYearService.clearSelectedFinancialYear();
        }
      }

      // Navigate immediately using setTimeout to ensure Angular has initialized
      // This prevents the redirecting component from being visible
      setTimeout(() => {
        if (this.userAuthService.systemId() == 34) {
          // settings
          if (goToHome) {
            // Force navigation to Home and clear the param
            this.router.navigate(['Home']);
          } else {
            const hasVisitedSettings = sessionStorage.getItem('hasVisitedSettings');
            if (!hasVisitedSettings) {
              sessionStorage.setItem('hasVisitedSettings', 'true');
              this.router.navigate(['Home']);
            } else {
              this.router.navigate(['MyAccount']);
            }
          }
        } else if (this.userAuthService.systemId() == 35) {
          // admin
          this.router.navigate(['Dashboard']);
        } else if (this.userAuthService.systemId() == 25) {
          // crm
          this.router.navigate(['DashBoard']);
        } else if (this.userAuthService.systemId() == 31) {
          // ims
          this.router.navigate(['IMSKPI']);
        } else if (this.userAuthService.systemId() == 37) {
          // purchase
          this.router.navigate(['DashBoard']);
        } else if (this.userAuthService.systemId() == 38) {
          // sales
          this.router.navigate(['SaleKPI']);
        } else if (this.userAuthService.systemId() == 28) {
          // fin
          this.router.navigate(['DashBoard']);
        } else if (this.userAuthService.systemId() == 135) {
          // payrool
          this.router.navigate(['KPI']);
        } else if (this.userAuthService.systemId() == 131) {
          // RSD
          this.router.navigate(['MainPage']);
        } else if (this.userAuthService.systemId() == 144) {
          // Integration: users (and visiting marketplace reviewers) who only have the marketplace
          // pages would land on /unauthorized from MainPage
          this.userAuthService
            .getPagesLoadedObservable()
            .pipe(take(1))
            .subscribe((pages) => {
              const routes = pages.flatMap((e) => (e.children?.length ? e.children : [e])).map((e) => e?.route);
              this.router.navigate([!routes.includes('MainPage') && routes.includes('Marketplace') ? 'Marketplace' : 'MainPage']);
            });
        } else if (this.userAuthService.systemId() == 145) {
          // Restaurant
          this.router.navigate(['MenuDashboard']);
        } else if (this.userAuthService.systemId() == 146) {
          // Finashop
          this.router.navigate(['Dashboard']);
        } else if (this.userAuthService.systemId() == 147) {
          // Developer Portal
          this.router.navigate(['Apps']);
        }
      }, 0);
    }

    // Show the redirecting message after 1 second if navigation is delayed
    this.messageTimer = window.setTimeout(() => {
      this.showMessage = true;
    }, 1000);

    // show the redirectting button after 5 seconds
    this.hideButtonTimer = window.setTimeout(() => {
      this.showButton = true;
    }, 5000);
  }

  ngOnDestroy(): void {
    if (this.hideButtonTimer) {
      clearTimeout(this.hideButtonTimer);
    }
    if (this.messageTimer) {
      clearTimeout(this.messageTimer);
    }
  }

  reloadHome(): void {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      window.location.reload();
    });
  }
}
